/** @jsxRuntime classic */
/** @jsx React.createElement */
/** @jsxFrag React.Fragment */
const React = require('react');
const { Helmet } = require('react-helmet-async');
const { useLocation } = require('react-router-dom');
const {
  getPublicPageSeo,
  isNoindexPath,
  isPageManagedMetadataPath,
} = require('../site/publicPageSeo');
const { ogImageUrlForPath } = require('../site/ogTitleCard');
const { SITE_BASE_URL } = require('../site/siteRoutes');

function dynamicMetadata(pathname) {
  if (pathname.startsWith('/blog/')) {
    return {
      path: pathname,
      title: 'BotSpot Blog Article',
      description: 'Market analysis, AI trading insights, and product updates from BotSpot.',
    };
  }
  if (pathname.startsWith('/marketplace/strategy/')) {
    return {
      path: pathname,
      title: 'AI Trading Strategy | BotSpot Marketplace',
      description: 'Review strategy details, backtest results, and live trading history in the BotSpot marketplace.',
    };
  }
  return null;
}

function PublicRouteSeo() {
  const { pathname } = useLocation();
  const normalizedPathname = pathname === '/' ? '/' : pathname.replace(/\/+$/, '');
  if (
    isNoindexPath(normalizedPathname)
    || isPageManagedMetadataPath(normalizedPathname)
    || normalizedPathname.startsWith('/blog/')
    || normalizedPathname.startsWith('/marketplace/strategy/')
  ) return null;
  const metadata = getPublicPageSeo(normalizedPathname) || dynamicMetadata(normalizedPathname);
  if (!metadata) return null;

  const canonical = `${SITE_BASE_URL}${normalizedPathname}`;
  const image = metadata.image || ogImageUrlForPath(normalizedPathname);
  return (
    <Helmet>
      <title>{metadata.title}</title>
      <meta name="description" content={metadata.description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={metadata.title} />
      <meta property="og:description" content={metadata.description} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={metadata.title} />
      <meta name="twitter:description" content={metadata.description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}

module.exports = PublicRouteSeo;
